import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthentService, AuthenticationRole } from '../Services/authent.service';
import { SharingDataService } from '../Services/sharing-data.service';
import { TranslateResourceDefinitionPipe } from '../shared/pipes/translateResourceDefinition.pipe';

@Component({
  selector: 'app-statistic-grid',
  templateUrl: './statistic-grid.component.html',
  styleUrls: ['./statistic-grid.component.css']
})
export class StatisticGridComponent implements OnInit {

  urlString;
  defaultFilter;
  defaultOrderby = [["G3E_FID"],["down"]];
  User;
  title;
  resourceDefinition;
  routerString;
  previousUrl;
  id1;
  id2;
  company = "";

constructor(
    private router: Router,
    public authService: AuthentService,
    private shareData: SharingDataService,
    public route: ActivatedRoute,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
  ) { }

  authRole = AuthenticationRole;

  columns = [
    {name: "STATKEY",                     visible: false,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",       columnSearch : false,   fromToFilter : true,    picklistTableName : null,                            function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "RQTITLE",                     visible: false,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",       columnSearch : false,   fromToFilter : false,   picklistTableName : null,                            function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "G3E_FID",                     visible: true,    enableFilter: true,  enableOrderBy: true,    export : true,    type : "text",       columnSearch : false,   fromToFilter : true,    picklistTableName : null,                            function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "PERSON",                      visible: true,    enableFilter: true,  enableOrderBy: true,    export : true,    type : "text",       columnSearch : true,    fromToFilter : false,   picklistTableName : null,                  function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "DELIVERY_STATE",              visible: true,    enableFilter: true,  enableOrderBy: true,    export : true,    type : "picklist",   columnSearch : false,   fromToFilter : false,   picklistTableName : "V_MS_DELIVERY_STATE_VL_T",      function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "REQUEST_STATE",               visible: true,    enableFilter: true,  enableOrderBy: true,    export : false,   type : "picklist",   columnSearch : false,   fromToFilter : false,   picklistTableName : "V_MS_REQUEST_STATE_VL_T",       function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "ACTIVITY_TYPE",               visible: true,    enableFilter: true,  enableOrderBy: true,    export : true,    type : "picklist",   columnSearch : false,   fromToFilter : false,   picklistTableName : "V_MS_ACTIVITY_TYPE_VL_T",       function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "REASON_TYPE",                 visible: true,    enableFilter: true,  enableOrderBy: true,    export : true,    type : "picklist",   columnSearch : false,   fromToFilter : false,   picklistTableName : "V_MS_REASON_TYPE_VL_T",         function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "BEGIN_ACTIVITY_DT",           visible: true,    enableFilter: true,  enableOrderBy: true,    export : true,    type : "date",       columnSearch : false,   fromToFilter : false,   picklistTableName : null,                            function : "toStatisticPage",          dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "REQUEST_DT",                  visible: true,    enableFilter: true,  enableOrderBy: true,    export : true,    type : "date",       columnSearch : false,   fromToFilter : false,   picklistTableName : null,                            function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
    {name: "LOCATION_DESC",               visible: true,    enableFilter: true,  enableOrderBy: true,    export : true,    type : "text",       columnSearch : true,    fromToFilter : false,   picklistTableName : null,                            function : "toStatisticPage",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null, defaultTextFilter: null},
  ]

  action(parameters){
    this[parameters.action](parameters.element, parameters.column);
  }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
    this.shareData.currentUser.subscribe(data => {
      if(data != null){
        this.User = data;
        if (this.authService.currentUser().ROLE == AuthenticationRole.ExternalAdmin) {
          this.externalOnInit();
        }
        if (this.authService.currentUser().ROLE == AuthenticationRole.InternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.InternalUser) {
          this.internalOnInit();
        }
        if (this.authService.currentUser().ROLE == AuthenticationRole.ExternalUser || this.authService.currentUser().ROLE == AuthenticationRole.Public) {
          this.externalOnInit();
        }
      }
    });
  }

  externalOnInit(){
    this.defaultFilter = `COMPANY_MID eq ${this.User.COMPANY_MID}`;
    this.urlString = "statistic/V_MS_STAT_ALL";
  }

  internalOnInit(){
    this.route.queryParams
    .subscribe(params => {
      if (params.id1 != undefined) {
        this.id1 = params.id1;
      }

      if (params.id2 != undefined) {
        this.id2 = params.id2;
      }
      if (params.company != undefined) {
        this.company = params.company;
      }
      this.routerString = "";
      if(this.router.url.indexOf("?")>0){
        this.routerString = this.router.url.substr(0, this.router.url.indexOf("?"));
      } else {
        this.routerString = this.router.url;
      }

      if (this.routerString === '/statisticGrid') {
        this.title = "statisticGrid";
        this.defaultFilter = ``;
      }
      if (this.routerString === '/gipReqStatEList') {
        this.title = "gipReqStatEList";
        this.defaultFilter = `REQUEST_STATE in ('5','13')`;
      }
      if (this.routerString === '/gipReqStatCAllList') {
        this.previousUrl = "/gipReqStatCList";
        this.title = "gipReqStatCAllList";
        this.defaultFilter = `COMPANY_MID eq ${this.id1}`;
      }
      if (this.routerString === '/gipReqStatCaAllList') {
        this.previousUrl = "/gipReqStatCaList";
        this.title = "gipReqStatCaAllList";
        this.defaultFilter = `ACTIVITY_TYPE eq '${this.id1}' and COMPANY eq '${this.id2}'`;
      }
      if (this.routerString === '/gipReqStatSAllList') {
        this.previousUrl = "/gipReqStatSList";
        this.title = "gipReqStatSAllList";
        this.defaultFilter = `REQUEST_STATE eq '${this.id1}'`;
      }
      if (this.routerString === '/gipReqStatCsAllList') {
        this.previousUrl = "/gipReqStatCsList";
        this.title = "gipReqStatCsAllList";
        this.defaultFilter = `REQUEST_STATE eq '${this.id1}' and COMPANY eq '${this.id2}'`;
      }
      if (this.routerString === '/gipReqStatAAllList') {
        this.previousUrl = "/gipReqStatAList";
        this.title = "gipReqStatAAllList";
        this.defaultFilter = `ACTIVITY_TYPE eq '${this.id1}'`;
      }
      this.urlString = "statistic/V_MS_STAT_ALL";
    });
  }

  publicOnInit(){
    this.defaultFilter = `USERGUID eq '${this.User.USERGUID}'`;
  }

  toStatisticPage(element, column){
    this.router.navigate(["/statisticForm"], { queryParams: { id: `G3E_FID eq ${element.G3E_FID}`, previousUrl: this.routerString, id1: this.id1, id2: this.id2}});
  }

  back(){
    this.router.navigate([this.previousUrl]);
  }
}
